const API_URL_LOCAL = 'http://localhost:3000/api';
const API_URL_PROD = 'https://admin-dashboard-template-liard.vercel.app/api';

const API_URL = API_URL_PROD;

export async function loginppr(data) {
    const response = await fetch(API_URL + '/loginppr', {
        method: 'POST',
        body: JSON.stringify(data)
    });

    return response;
}

export async function getLeadsById(idReferrer) {
    const response = await fetch(API_URL + '/leads/' + idReferrer);

    return response.json();
}

export async function getLeadsByIdEdit(idReferrer, idLead) {
    const response = await fetch(API_URL + '/leads/' + idReferrer + '?idLead=' + idLead);

    return response.json();
}

export async function getConsortiumAgencies() {
    const response = await fetch(API_URL + '/consortiumagencies');

    return response.json();
}

export async function getBanks() {
    const response = await fetch(API_URL + '/bank');

    return response.json();
}

export async function editLeadsByIdEdit(idLead, data) {
    //console.log('editLeadsByIdEdit',data)
    try {
        const response = await fetch(`${API_URL}/leads/${idLead}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error(`Erro ao editar referrer: ${response.status} - ${response.statusText} - ${await response.text()}`);
        }

        const responseData = await response.json();
        //console.log(responseData)
        return responseData;
    } catch (error) {
        //console.error('Erro na requisição:', error);
        throw new Error(`Erro ao editar referrer: ${error.message}`);
    }
}

export async function newReferrer(data) {
    const response = await fetch(API_URL + '/referrers', {
        method: 'POST',
        body: JSON.stringify(data)
    });

    await fetch(API_URL + '/messages/13', {
        method: 'POST',
        body: JSON.stringify({
            title: "Novo Indicador",
            message: data.name + " tornou-se um indicador",
            message_types_id: 4,
            redirect_link: "/indicadores"
        }),
    });

    return response;
}

export async function newLead(data, idReferrer) {
    const response = await fetch(API_URL + '/leads/' + idReferrer, {
        method: 'POST',
        body: JSON.stringify(data)
    });

    await fetch(API_URL + '/messages/13', {
        method: 'POST',
        body: JSON.stringify({
            title: "Nova indicação",
            message: "Você tem uma nova indicação PPR",
            message_types_id: 4,
            redirect_link: "/indicacoes"
        }),
    });

    return response.json();
}

export async function newDocRapidoQuotasAcquisition(data) {
    const response = await fetch(API_URL + '/docrapido_quotasacquisitions', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (!response.ok) {
        throw new Error(`Erro ao criar aquisicao DocRapido: ${response.status} - ${response.statusText}`);
    }

    return response.json();
}

export async function getDocRapidoQuotasAcquisitionById(id) {
    const response = await fetch(`${API_URL}/docrapido_quotasacquisitions/${id}`);

    if (!response.ok) {
        throw new Error(`Erro ao buscar aquisicao DocRapido: ${response.status} - ${response.statusText}`);
    }

    return response.json();
}

export async function editDocRapidoQuotasAcquisitionById(id, data) {
    const response = await fetch(`${API_URL}/docrapido_quotasacquisitions/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        throw new Error(`Erro ao editar aquisicao DocRapido: ${response.status} - ${response.statusText}`);
    }

    return response.json();
}

export async function newDocRapidoQuota(data) {
    const response = await fetch(API_URL + '/docrapido_quotas', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (!response.ok) {
        throw new Error(`Erro ao criar cota DocRapido: ${response.status} - ${response.statusText}`);
    }

    return response.json();
}

export async function getDocRapidoQuotaById(id) {
    const response = await fetch(`${API_URL}/docrapido_quotas/${id}`);

    if (!response.ok) {
        throw new Error(`Erro ao buscar cota DocRapido: ${response.status} - ${response.statusText}`);
    }

    return response.json();
}

export async function editDocRapidoQuotaById(id, data) {
    const response = await fetch(`${API_URL}/docrapido_quotas/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        throw new Error(`Erro ao editar cota DocRapido: ${response.status} - ${response.statusText}`);
    }

    return response.json();
}

export async function deleteDocRapidoQuotaById(id) {
    const response = await fetch(`${API_URL}/docrapido_quotas/${id}`, {
        method: 'DELETE',
    });

    if (!response.ok) {
        throw new Error(`Erro ao deletar cota DocRapido: ${response.status} - ${response.statusText}`);
    }

    return true;
}

export async function getDocRapidoQuotasAcquisitionsByConsultant(consultantId) {
    const response = await fetch(`${API_URL}/docrapido_quotasacquisitions/view?consultant_id=${consultantId}`);

    if (!response.ok) {
        throw new Error(`Erro ao buscar aquisicoes DocRapido: ${response.status} - ${response.statusText}`);
    }

    return response.json();
}

export async function getConsultantById(consultantId) {
    const response = await fetch(`${API_URL}/consultants/${consultantId}`);

    if (!response.ok) {
        throw new Error(`Erro ao buscar consultor: ${response.status} - ${response.statusText}`);
    }

    return response.json();
}

export async function editConsultantById(consultantId, data) {
    const response = await fetch(`${API_URL}/consultants/${consultantId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        throw new Error(`Erro ao editar consultor: ${response.status} - ${response.statusText}`);
    }

    return response.json();
}

export async function editConsultantBankAccountById(bankAccountId, data) {
    const response = await fetch(`${API_URL}/consultantsbankaccount/${bankAccountId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        throw new Error(`Erro ao editar dados bancarios do consultor: ${response.status} - ${response.statusText}`);
    }

    return response.json();
}

export async function getReferrersById(idReferrer) {
    const response = await fetch(API_URL + '/referrers/' + idReferrer);

    const responseData = await response.json();
    return responseData;
}

export async function editReferrerById(referrerId, data) {
    try {
        const response = await fetch(`${API_URL}/referrers/${referrerId}`, {
            method: 'PUT', // ou 'PATCH' dependendo do seu caso
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error(`Erro ao editar referrer: ${response.status} - ${response.statusText}`);
        }

        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Erro na requisição:', error);
        throw error; // Você pode optar por tratar ou relançar o erro, dependendo do seu caso de uso.
    }
}

export async function getChatByLeadId(idLead) {
    const response = await fetch(API_URL + '/chat/' + idLead);

    const responseData = await response.json();
    return responseData;
}

export async function newChat(data, idLead) {
    const response = await fetch(API_URL + '/chat/' + idLead, {
        method: 'POST',
        body: JSON.stringify(data)
    });

    return response.json();
}

export async function editDataBank(referrerId, data) {
    try {
        const response = await fetch(`${API_URL}/referrers/${referrerId}`, {
            method: 'PUT', // ou 'PATCH' dependendo do seu caso
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error(`Erro ao editar referrer: ${response.status} - ${response.statusText}`);
        }

        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Erro na requisição:', error);
        throw error; // Você pode optar por tratar ou relançar o erro, dependendo do seu caso de uso.
    }
}

export async function loginIntermediary(data) {
    const response = await fetch(API_URL + '/loginIntermediary', {
        method: 'POST',
        body: JSON.stringify(data)
    });

    return response;
}

export async function forgotPasswordIntermediary(data) {
    const response = await fetch(API_URL + '/intermediary/forgot-password', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    return response;
}

export async function newIntermediary(data) {
    const response = await fetch(API_URL + '/consultants/newconsultants', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    if (response.status === 201) {
        await fetch(API_URL + '/messages/16', {
            method: 'POST',
            body: JSON.stringify({
                title: "Novo Intermedário",
                message: data.consultant_name + " tornou-se um Intermedário",
                message_types_id: 5,
                redirect_link: "/consultores?t=intermediario"
            }),
        });
    }

    return response;
}
